import React from "react";

const DataLoader = ({ show }) => {
  if (!show) return null;
  return (
    <div style={{
      position: "absolute",
      inset: 0,
      zIndex: 20,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 10,
      background: "#ffffff",
    }}>
      <div style={{
        width: 28,
        height: 28,
        borderRadius: "50%",
        border: "2.5px solid #E5E7EB",
        borderTopColor: "#2563EB",
        animation: "spin 0.65s linear infinite",
      }} />
      <span style={{ fontSize: 12, color: "#94A3B8", fontWeight: 500 }}>Məlumatlar yüklənir...</span>
    </div>
  );
};

export default DataLoader;
